import { memo } from 'react'
import { Box, Typography } from '@maas-components/core'
import i18n from 'core/common/i18n'
import { TOptionsWithAvatarProps } from './types'
import VariationAvatar from './VariationAvatar'

const Option = ({ option, showAvatar, noResults }: TOptionsWithAvatarProps) => {
  if (option.inputValue && noResults && !/^\++$/.test(option.inputValue)) {
    return (
      <Box
        className="w-100 pr-2"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        data-testid="render-option-new"
      >
        <Typography component="span" className="p-1 d-flex align-center" variant="body1" noWrap>
          <VariationAvatar option={option} showAvatar={showAvatar} />
          <Typography
            className="pl-1"
            data-testid={`autocomplete-opt-${option.title}`}
            component="span"
          >
            {option.title}
          </Typography>
        </Typography>
        <Typography variant="subtitle1" color="primary">
          {i18n.t('general.add')}
        </Typography>
      </Box>
    )
  }

  return (
    <Typography component="span" className="p-1 d-flex align-center" variant="body1" noWrap>
      <VariationAvatar option={option} showAvatar={showAvatar} />
      <Typography
        data-testid={`autocomplete-opt-${option.title}`}
        className="pl-1"
        component="span"
      >
        {option.title}
      </Typography>
    </Typography>
  )
}

export default memo(Option)
